<template>
  <svg viewBox="0 0 400 360" role="img" aria-label="Rumah dengan kamar pribadi, kamar bersama, dan ruang keluarga">
    <ellipse cx="200" cy="334" rx="170" ry="12" fill="#000" opacity=".18" />

    <!-- Roof & chimney -->
    <rect x="270" y="48" width="26" height="62" rx="4" fill="#C26A35" />
    <path d="M36 138 200 36l164 102Z" fill="#E0915F" stroke="#E0915F" stroke-width="12" stroke-linejoin="round" />
    <circle cx="200" cy="100" r="20" fill="#F6F1E7" />
    <path transform="translate(155.2 44.7) scale(1.4)"
      d="M32 47c-9.5-6.3-9-14.5-4-14.5 2.4 0 3.6 1.7 4 3 .4-1.3 1.6-3 4-3 5 0 5.5 8.2-4 14.5Z" fill="#E0915F" />

    <!-- Body -->
    <rect x="60" y="130" width="280" height="194" rx="10" fill="#F6F1E7" />

    <!-- Top-left: private room -->
    <rect x="72" y="142" width="122" height="80" rx="6" fill="#EFE8DA" />
    <rect x="86" y="156" width="36" height="30" rx="4" fill="#A9C4A5" />
    <path d="M104 156v30M86 171h36" stroke="#F6F1E7" stroke-width="3" />
    <rect x="128" y="200" width="54" height="6" rx="3" fill="#C26A35" />
    <circle cx="150" cy="180" r="9" fill="#E3B58F" />
    <rect x="139" y="190" width="22" height="28" rx="9" fill="#6B8F71" />
    <circle cx="178" cy="158" r="12" fill="#2F4A3A" />
    <path d="M174.5 157v-2.5a3.5 3.5 0 0 1 7 0v2.5" fill="none" stroke="#F2B98F" stroke-width="2" />
    <rect x="172" y="157" width="12" height="9" rx="2" fill="#F2B98F" />

    <!-- Top-right: shared with selected members -->
    <rect x="206" y="142" width="122" height="80" rx="6" fill="#E5EEE4" />
    <circle cx="240" cy="178" r="9" fill="#C98E66" />
    <rect x="228" y="188" width="24" height="34" rx="10" fill="#E0915F" />
    <circle cx="278" cy="174" r="10" fill="#E3B58F" />
    <rect x="265" y="185" width="26" height="37" rx="11" fill="#2F4A3A" />
    <circle cx="312" cy="158" r="12" fill="#6B8F71" />
    <circle cx="308" cy="155" r="3" fill="#F6F1E7" />
    <circle cx="316" cy="155" r="3" fill="#F6F1E7" />
    <path d="M303 164a5 4 0 0 1 10 0M311 164a5 4 0 0 1 10 0" fill="#F6F1E7" />

    <!-- Bottom: whole household -->
    <rect x="72" y="234" width="256" height="78" rx="6" fill="#FBE7D8" />
    <ellipse cx="190" cy="306" rx="96" ry="6" fill="#E0915F" opacity=".35" />
    <circle cx="280" cy="262" r="28" fill="#F2B98F" opacity=".45" />
    <path d="M280 302v-46" stroke="#2F4A3A" stroke-width="3" />
    <path d="M266 256h28l-6-16h-16Z" fill="#E0915F" />
    <circle cx="146" cy="254" r="10" fill="#C98E66" />
    <circle cx="180" cy="250" r="11" fill="#E3B58F" />
    <circle cx="212" cy="258" r="8" fill="#B47A55" />
    <rect x="114" y="262" width="132" height="30" rx="10" fill="#6B8F71" />
    <rect x="106" y="280" width="148" height="22" rx="8" fill="#4F7A5C" />
    <rect x="100" y="270" width="16" height="32" rx="7" fill="#4F7A5C" />
    <rect x="244" y="270" width="16" height="32" rx="7" fill="#4F7A5C" />
    <rect x="309" y="286" width="20" height="18" rx="3" fill="#C26A35" />
    <ellipse cx="313" cy="274" rx="5" ry="11" fill="#6B8F71" transform="rotate(-20 313 274)" />
    <ellipse cx="324" cy="274" rx="5" ry="11" fill="#A9C4A5" transform="rotate(20 324 274)" />
    <circle cx="88" cy="248" r="12" fill="#E0915F" />
    <path transform="translate(73.6 230.1) scale(.45)"
      d="M32 47c-9.5-6.3-9-14.5-4-14.5 2.4 0 3.6 1.7 4 3 .4-1.3 1.6-3 4-3 5 0 5.5 8.2-4 14.5Z" fill="#fff" />
  </svg>
</template>

<script>
export default {
  name: "IlloHouseRooms",
};
</script>
